import { useAtomValue } from 'jotai';

import {
  applyClinicianTrialExtensionDevOverride,
  clinicianTrialExtensionDevOverrideAtom,
} from './clinician-trial-end-dev-override';

/**
 * Whether the trial card offers "Extend your trial": the checklist is open to
 * the member and not yet completed. Dev tools can force either state.
 */
export function useClinicianTrialExtensionAvailable(isAvailable: boolean): boolean {
  const devOverride = applyClinicianTrialExtensionDevOverride(
    useAtomValue(clinicianTrialExtensionDevOverrideAtom)
  );
  return devOverride == null ? isAvailable : !devOverride.completed;
}
